/*
 * @Author: 15708496481 15708496481@163.com
 * @Date: 2022-03-29 10:13:55
 * @LastEditors: 15708496481 15708496481@163.com
 * @LastEditTime: 2022-05-17 17:01:16
 * @FilePath: \zhaoshengbao\src\assets\request\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// api.js
import request from './request'
// 查询电子简章列表
export const GetBookFindApi = params => request.get('/api/book/find',{params})
//  获取用户信息
export const GetLoginApi = (params) => request.post('/api/user/fakelogin',params)
//  拿到所有的省份
export const  GetProvinceApi = (params) => request.get('/api/sys/province/find',{params})

//  添加日志
export const  AddLogApi = (params) => request.post('/api/sys/log/add',{...params})
//  拿到所有 专场 信息
export const GetSpecialApi = (params) => request.get('/api/stream/groups/find',{params})

// 拿到聊天室聊天内容
export const GetChatroomApi = (params) => request.get('/api/chat/find',{params})


//  获取宣讲
export const GetStreamList = (params) => request.get('/api/stream/find/day',{params})


//  获取某时间段每天宣讲数量
export const GetStreamCountList = (params) => request.get('/api/stream/count/find',{params})

// 获取线下活动
export const GetEventOffList = (params) => request.get('/api/event/eventoff/find',{params})

// 获取推广资讯
export const FindPromotionList = (params) => request.post('/api/stream/promotion/find',params)
// 获取线下活动详情
export const GetEventOffDetail = (params) => request.get('/api/event/eventoff/get',{params})
//  线下活动报名
export const EventoffApply = (params) => request.post('/api/event/eventoff/reg/apply',params)
//  线下活动签到
export const EventoffSign = (params) => request.post('/api/event/off/register/sign',params)

// 获取咨询列表

export const GetConsultList = (params) => request.get('/api/uni/consult/find',{params})
// 获取线下活动详情
export const GetConsultDetail = (params) => request.get('/api/uni/consult/get',{params})



// WEBPACK FOOTER //
// ./src/assets/request/api.js